import React from 'react';
import { ThemedView, ThemedText } from '@app/theme';
import { Shimmer } from '@app/sharedComponents/Shimmer/Shimmer';

export const PledgeHistoryItemShimmer = () => {
  return (
    <ThemedView margin="lg">
      <Shimmer width={100} height={16} />
      <ThemedView borderRadius="sm" borderWidth={1} padding="lg" marginTop="sm" borderColor="border-primary">
        <Shimmer width={120} height={18} />
        <ThemedView marginTop="sm" flexDirection="row" justifyContent="space-between">
          <Shimmer width={100} height={16} />
          <Shimmer width={80} height={16} />
        </ThemedView>
        <ThemedView marginTop="sm" flexDirection="row" justifyContent="space-between">
          <Shimmer width={60} height={16} />
          <Shimmer width={100} height={16} />
        </ThemedView>
        <ThemedView my="lg" backgroundColor="border-secondary" height={1} width="100%" />
        <ThemedView alignItems="flex-end">
          <Shimmer width={80} height={16} />
        </ThemedView>
      </ThemedView>
    </ThemedView>
  );
}; 